<template>
    <div v-if="loading" class="text-center" style="margin-top: 10em">
        <div class="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    <div v-else>
        <transition appear name="slide-fade">
            <div class="row">
                <div class="col-12">
                    <button_back></button_back>
                </div>
                <div class="col-12">
                    <h3 class="text-orange mt-3">{{ title }}</h3>
                </div>
                <div class="col-lg-4">
                    <router-link to="/solicitudes_aliados_plataforma">
                        <div class="card" style="background-color: #000">
                            <div class="card-body">
                                <h4 class="text-white mt-2">
                                    <span class="cirle">
                                        <i class="align-middle bx bxs-graduation bx-sm"></i>
                                    </span>
                                    Solicitudes Plataforma Educativa
                                </h4>
                            </div>
                        </div>
                    </router-link>
                    <!-- <router-link to="/solicitudes_plataforma">
                        <div class="card" style="background-color: #000">
                            <div class="card-body">
                                <h4 class="text-white mt-2">
                                    <span class="cirle">
                                        <i class='align-middle bx bxs-key bx-sm' ></i>
                                    </span>
                                    Usuarios Aliados
                                </h4>
                            </div>
                        </div>
                    </router-link> -->
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
export default {
    name: 'Beneficios_aliados',
    components: {
        button_back: defineAsyncComponent(() => import('../../../components/BackBtn')),
    },
    data() {
        return {
            loading: true,
            title: null
        };
    },
    created: function () {
        this.getTitle();
    },
    methods: {
        getTitle() {
            this.title = 'Beneficios aliados'
            this.loading = false
        }
    }
}
</script>
<style scoped>
span.cirle {
    background: #ffffff;
    padding: 12px 10px;
    border-radius: 100%;
    margin-right: 20px;
}

span.cirle i.align-middle.bx.bx-sm {
    color: #ff6700;
}
</style>